import { useSelector } from 'react-redux'

import logo from 'assets/integrations/linear/icon.svg'
import { selectCurrentTicketId } from 'ducks/tickets/selectors/selectCurrentTicketId'

import NavigatableIntegrationWidgetCard from '../NavigatableIntegrationWidgetCard'
import LinkedLinearIssuesIndex from './LinkedLinearIssuesIndex'
import LinkedLinearIssue from './LinkedLinearIssue'

export default function LinearWidgetCard({ doHideCard }) {
  const conversationId = useSelector(selectCurrentTicketId)
  if (!conversationId) return null
  return (
    <NavigatableIntegrationWidgetCard
      detailComponent={LinkedLinearIssue}
      doHideCard={doHideCard}
      image={logo}
      indexComponent={LinkedLinearIssuesIndex}
      title="Linear"
      persistenceKey="linear"
    />
  )
}
